<template>
    <nav class="nav-link montserrat" :class="menuShow ? 'open' : ''">
        <div class="content">
            <div class="top">
                <div class="center">
                    <div class="menu">
                        <button class="btn-menu" @click="toggleMenu"><i class="fa-solid fa-bars"></i></button>
                        <div class="theme-switcher">
                            <label class="switch">
                                <input type="checkbox" v-model="isDarkTheme" @change="themeSwitcher"
                                    class="theme-toggle">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="logo">
                        <img src="../assets/utility/logo/Logo LR Pro Marketing - circular - sin slogan.png"
                            title="Logo Lr Pro Marketing" alt="Logo Lr Pro marketing circular sin slogan">
                        <!-- <span>LR PRO <br>Marketing</span> -->
                    </div>
                    <div class="options">
                        <a href="tel:+182980733710" title="Llamar ahora"><i class="fa-solid fa-phone"></i><span>+1 (829)
                                807-3310</span></a>
                    </div>
                </div>
            </div>
            <div class="down nunito">
                <ul>
                    <li>
                        <router-link title="Ir a la página inicio" :to="'/'" :class="{ active: activeLink === '/' }"
                            @click="setActiveLink('/')">Inicio</router-link>
                    </li>

                    <li>
                        <router-link title="Ir a la página de servicios" :to="'/services'"
                            :class="{ active: activeLink === '/services' }"
                            @click="setActiveLink('/services')">Servicios</router-link>
                    </li>
                    <li>
                        <router-link title="Ir a la página de Planes" :to="'/plans'"
                            :class="{ active: activeLink === '/services' }"
                            @click="setActiveLink('/plans')">Planes</router-link>
                    </li>
                    <li>
                        <router-link title="Ir a la página de portafolio" :to="'/portfolio'"
                            :class="{ active: activeLink === '/portfolio' }"
                            @click="setActiveLink('/portfolio')">Portafolio</router-link>
                    </li>
                    <li>
                        <router-link title="Ir a la página de contactos" :to="'/contact'"
                            :class="{ active: activeLink === '/contact' }"
                            @click="setActiveLink('/contact')">Contactos</router-link>
                    </li>
                    <!-- <li>
                        <router-link title="Ir a la página de Casos clínicos" :to="'/blogs'"
                            :class="{ active: activeLink === '/blogs' }"
                            @click="setActiveLink('/blogs')">Blogs</router-link>
                    </li> -->
                    <!-- <li>
                        <router-link title="Ir a la página de Nosotros" :to="'/about'"
                            :class="{ active: activeLink === '/about' }"
                            @click="setActiveLink('/about')">Nosotros</router-link>
                    </li> -->
                    <!-- <li>
                        <router-link title="Ir a la página de blogs" :to="'/blogs'"
                            :class="{ active: activeLink === '/blogs' }"
                            @click="setActiveLink('/blogs')">Blogs</router-link>
                    </li> -->
                </ul>
            </div>
        </div>
    </nav>

    <div class="nav-link-clone"></div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';

export default {
    setup() {
        const activeLink = ref('/');
        const menuShow = ref(true);
        const route = useRoute();
        const isDarkTheme = ref(false);

        const setActiveLink = (link) => {
            activeLink.value = link;
        };

        const themeSwitcher = () => {
            document.body.classList.toggle('dark-theme', isDarkTheme.value);
        };

        const isContactPage = ref(route.path === '/contact');

        watch(route, () => {
            isContactPage.value = route.path === '/contact';
        });

        onMounted(() => {
            isContactPage.value = route.path === '/contact';
        });

        return {
            activeLink,
            menuShow,
            setActiveLink,
            themeSwitcher,
            isContactPage,
            isDarkTheme
        };
    },
    methods: {
        toggleMenu() {
            this.menuShow = !this.menuShow;
        }
    }
};
</script>



<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
$max-width-body: 1280px;

.nav-link.open,
.nav-link.open~.nav-link-clone {
    width: 100%;
    transition: height 0.5s;

    @media (min-width: $breakpoint-md) {
        height: 150px;
    }
}

.nav-link,
.nav-link-clone {
    width: 100%;
    height: 100px;
    transition: height 0.5s;
}


body.dark-theme .nav-link {
    background: #131415;
    color: white;
    transition: background-color 0.2s, color 0.2s;

    .top {
        border-bottom: 1px solid #333333;

        .center {
            .menu {

                .btn-menu {
                    border-color: rgb(142, 142, 142);
                    color: white;

                    &:hover {
                        background: rgb(0, 110, 255);
                        border-color: rgb(0, 110, 255);
                    }
                }

                .theme-switcher {

                    .switch {

                        input {

                            &:checked+.slider {
                                background-color: #272a2f;
                            }

                            &:checked+.slider:before {
                                // transform: translateX(26px);
                            }

                            &:hover+.slider {
                                // box-shadow: 0 0 3px rgb(47, 47, 47);
                            }
                        }
                    }

                    .slider {
                        background: #272a2f
                    }
                }

            }

            .options {
                a {
                    background: #cf7606;
                    color: black;

                }
            }
        }
    }

    .down {
        background:#131415;


        ul {
            a {
                color: #939393;

            }

            a.router-link-active {
                color: white;
            }
        }
    }
}

.nav-link.without-background {
    background: transparent;
    position: absolute;
}




.nav-link.open {
    @media (min-width: $breakpoint-md) {
        display: block;
    }
}

.nav-link {
    transition: background-color 0.3s, color 0.3s;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000000000;

    &.open {
        .content {
            .down {
                display: flex;
            }
        }
    }

    .content {
        height: 100%;
        width: 100%;
        margin: 0 auto;
        max-width: $max-width-body;

        .top {
            height: 100px;
            border-bottom: 1px solid #ececec;
            width: 100%;

            .center {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 100%;
                width: 90%;
                margin: 0 auto;

                @media (max-width:$breakpoint-md) {
                    justify-content: none;
                }

                .menu {
                    width: 30%;
                    display: flex;
                    align-items: center;

                    @media (max-width:$breakpoint-md) {
                        width: auto;
                    }

                    .btn-menu {
                        width: 40px;
                        height: 40px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background: transparent;
                        border-radius: 10px;
                        border: 1px solid #dadada;
                        cursor: pointer;

                        &:hover {
                            background: rgb(4, 2, 29);
                            color: white;
                        }

                        i {
                            margin: 0;
                            padding: 0;
                        }
                    }

                    .theme-switcher {
                        display: flex;
                        text-wrap: nowrap;
                        align-items: center;
                        margin: 20px;


                    }

                    .switch {
                        position: relative;
                        display: inline-block;
                        width: 60px;
                        height: 34px;
                        margin-right: 10px;

                        input {
                            opacity: 0;
                            width: 0;
                            height: 0;

                            &:checked+.slider {
                                background-color: #2196F3;
                            }

                            &:checked+.slider:before {
                                transform: translateX(26px);
                            }

                            &:hover+.slider {
                                // box-shadow: 0 0 3px rgb(47, 47, 47);
                            }
                        }
                    }

                    .slider {
                        position: absolute;
                        cursor: pointer;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background-color: #12121c;
                        transition: .4s;
                        border-radius: 34px;

                        &:before {
                            position: absolute;
                            content: "";
                            height: 26px;
                            width: 26px;
                            left: 4px;
                            bottom: 4px;
                            background-color: white;
                            transition: .4s;
                            border-radius: 50%;
                        }
                    }

                }

                .logo {
                    flex: 1;
                    text-align: center;
                    font-size: 32px;
                    justify-content: none;

                    img {
                        max-width: 80px;

                        @media (max-width:$breakpoint-md) {
                            max-width: 50px;

                        }
                    }

                    @media (max-width:$breakpoint-md) {
                        width: auto;
                        text-align: right;

                    }

                    i {
                        padding: 0;
                        margin: 0;
                    }

                    span {
                        font-weight: bold;
                        padding: 0;
                        margin: 0;
                    }
                }

                .options {
                    width: 30%;
                    display: none;
                    gap: 15px;
                    align-items: center;
                    justify-content: end;

                    @media (min-width: $breakpoint-md) {
                        display: flex;
                    }



                    a {
                        text-decoration: none;
                        background: #272a2f;
                        font-weight: 700;
                        padding: 15px 20px;
                        display: flex;
                        align-items: center;


                        text-wrap: nowrap;
                        color: #2ab672;
                        border-radius: 60px;

                        span {
                            padding-left: 10px;
                            display: none;

                            @media (min-width: $breakpoint-md) {
                                display: flex;
                            }
                        }

                        i {
                            color: #ffffff;
                            display: inline;
                        }
                    }
                }


            }
        }

        .down {
            height: 50px;
            background: rgb(255, 255, 255);
            display: none;
            justify-content: center;
            align-items: center;

            @media (min-width: $breakpoint-md) {
                &.open {
                    display: flex;
                }
            }


            ul {
                list-style: none;
                display: flex;
                gap: 40px;
                
                &::-webkit-scrollbar {
                    background-color: transparent;
                    height: 0px;
                }

                &::-webkit-scrollbar-thumb {
                    background: transparent;
                }

                @media (max-width: $breakpoint-md) {
                    padding:10px 20px;
                    justify-content: center;
                    overflow-x: auto;
                    width: 100%;

                }

                @media (max-width: 500px) {
                    justify-content: flex-start;
                }

                

                

                a {
                    text-decoration: none;
                    font-size: 16px;
                    font-weight: 600;
                    color: #0e0e0e;
                    position: relative;

                    &::before {
                        content: '•';
                        font-size: 24px;
                        position: absolute;
                        width: 100%;
                        text-align: center;
                        display: none;
                        left: 0;
                        bottom: -20px;
                    }
                }

                a.router-link-active {
                    &::before {
                        display: block;
                    }

                }
            }
        }

    }
}
</style>
